<template>
    <div  class="s-gray-bg p-user-select">
        <!--日期切换-->
        <div
                class="p-margin20 s-orange-bg p-font1 p-white-text p-center"
                style="width:22rem; height:2.5rem; overflow:hidden; padding:0.5rem; border-radius:1.75rem; line-height:2.5rem;"
                :style="`background:${  bgColor  };`"
        >
            <div  class="p-relative p-wh100">
                <!--运动按钮-->
                <div
                    class="p-box-center p-absolute"
                    :style="`width:calc(100% / ${  len  }); left:${  moveIndex * (100 / len)  }%`"
                    style="transition:500ms;"
                >
                    <div
                        class="p-white-bg s-lightOrange"
                        style="border-radius:1.25rem;  width:5rem; height:100%; overflow:hidden;"
                    >
                        &nbsp;
                    </div>
                </div>

                <ul  ref="timeList"  class="p-relative">
                    <li
                        @click="move(key,val)"
                        v-for="(val,key,index) in types"
                        :index="key"
                        :name="val"
                        :class="{ 's-lightOrange':index==moveIndex }"
                        class="p-float-left"
                        style="transition:500ms;"
                        :style="`width:calc(100% / ${  len  }); color:${  index==moveIndex ? activeTextColor : ''  }`"
                    >
                    <span  v-if="val==='日'"> {{$t('common.day')}}</span>
                    <span  v-else-if="val==='周'"> {{$t('common.week')}}</span>
                    <span  v-else-if="val==='月'"> {{$t('common.month')}}</span>
                    <span  v-else-if="val==='年'"> {{$t('common.year')}}</span>
                        <!-- {{val}} -->
                    </li>
                </ul>

            </div>
        </div>


        <!--时间段显示-->
        <div  class="p-font0-8 p-color1 p-center"  style="height:3rem; line-height:3rem;">
            <i  @click="toggleTime(false)"  class="iconfont iconxiangzuo p-font1 s-orange"  :style="`color:${  bgColor  }`"></i>
            <span  class="p-padding20">
                    <span  v-if="type==='日'">
                        {{  time(startTime).format($t('common.formatDateYMD'))}}
                        <!-- {{  time(startTime).format('YYYY-M-D').replace("-","年").replace("-","月") + "日"  }} -->
                    </span>
                    <span  v-else-if="type==='周'">
                        <!-- {{  time(startTime).format('YYYY-M-D').replace("-","年").replace("-","月") + "日"  }} -->
                        {{  time(startTime).format($t('common.formatDateYMD'))}}
                        {{$t('common.to')}}
                        {{  time(endTime).format($t('common.formatDateMD'))}}
                        <!-- {{  time(endTime).format('M-D').replace("-","月") + "日"  }} -->
                    </span>
                    <span  v-else-if="type==='月'">
                        {{  time(startTime).format($t('common.formatDateYM'))}}
                        <!-- {{  time(startTime).format('YYYY-M').replace("-","年") + "月"  }} -->
                    </span>
                    <span    v-else-if="type==='年'">
                        {{  time(startTime).format($t('common.formatDateYM'))}}
                        {{$t('common.to')}}
                        {{  time(endTime).format($t('common.formatDateM'))}}
                        <!-- {{  time(startTime).format('YYYY-M').replace("-","年") + "月"  }}
                        至
                        {{  time(endTime).format('M') + "月"  }} -->
                    </span>
                </span>
            <i  @click="toggleTime()"  class="iconfont iconxuanzeqixiayige p-font1 s-orange"  :style="`color:${  bgColor  }`"></i>

            <!--{{  test  }}-->
        </div>



        <!-- <div>
            <div>标记时间：{{newTime}}  {{time(newTime).format('YYYY-MM-DD HH:mm:ss')}}</div>
            <div>开始时间：{{startTime}} {{time(startTime).format('YYYY-MM-DD HH:mm:ss')}}</div>
            <div>结束时间：{{endTime}} {{time(endTime).format('YYYY-MM-DD HH:mm:ss')}}</div>
        </div> -->

    </div>
</template>

<script>
    /*
    <toggleTime  @sendTime="sendTime"  style="padding-top:1rem;"></toggleTime>
    <toggleTime  @sendTime="sendTime"  style="padding-top:1rem;"  :bg-color="'#1AAD19'"  :active-text-color="'#1AAD19'"  ></toggleTime>
    */

    import time from 'js-time.js'
    import {  getLimits  }  from '@/utils/methods.js'

    // let newTime = new Date().getTime();
    let newTime = time().valueOf();

    export default {
        name: "toggleTime",
        data(){
            return {
                type:this.$route.query.type ? decodeURI(this.$route.query.type)  : '年',
                newTime:Number(this.$route.query.newTime)>0 ? Number(this.$route.query.newTime) : newTime,       // 标记时间-------------------------
                startTime:'',
                endTime:'',

                // moveIndex:-1,  // 运动时的索引
                onoff:true,   // 避免重复点击

                /*test:'',*/
            }
        },
        props: {
            types:{  type:Object, required:false, default:function(){
                  return {
                      0:'日',
                      1:'周',
                      2:'月',
                      3:'年'
                  }
                }
            },
            bgColor:{  type:String, required:false, default:''  },
            activeTextColor:{  type:String, required:false, default:''  },
        },
        computed:{
            moveIndex(){
                let num = Object.keys(this.types).length;

                if(  this.type=='日'  )    num = num - 4;
                else if(  this.type=='周'  )    num = num - 3;
                else if(  this.type=='月'  )    num = num - 2;
                else if(  this.type=='年'  )    num = num - 1;

                /*console.log("this.type: ",this.type);
                console.log("num: ",num);
                console.log(Object.keys(this.types).length);*/

                return num;
            },
            len(){
                return Object.keys(this.types).length
            },
        },
        watch:{
            newTime(newValue,oldValue){
                 if(newValue!=oldValue){
                    console.log(" toggleTime  newValue: ",newValue,oldValue);
                    // alert(newValue,oldValue)
                    this.emitFn(this.type,newValue);
                 }
            },
        },
        methods:{
            time,
            // 获取时间段  (type,newTime,callback)  类型：日、周、月、年    标记时间戳：一般为现在时间    回调函数    依赖js-time.js插件
            getLimits,
            emitFn(type,tmpTime){
                this.startTime = this.getLimits(this.type,tmpTime)["startTime"];
                this.endTime = this.getLimits(this.type,tmpTime)["endTime"];

                // 通过自定义事件，返回时间插件相关的数据
                this.$emit("sendTime",{
                    tmpTime,
                    startTime:this.getLimits(type,tmpTime)["startTime"],
                    endTime:this.getLimits(type,tmpTime)["endTime"],
                    type,   // 日、周、月、年
                });

                /*console.log("返回时间-------",{
                    newTime,
                    startTime:this.getLimits(type,newTime)["startTime"],
                    endTime:this.getLimits(type,newTime)["endTime"],
                    type,   // 日、周、月、年
                });*/
            },
            // 点击左右滚动
            move(key,val){
                // 避免重复点击
                if(  this.type != val  ){
                    this.type = val;
                    // this.newTime = time().valueOf();  // 每次切换时，重置当前时间---------------------
                    this.newTime = Number(this.$route.query.newTime)>0 ? Number(this.$route.query.newTime) : newTime;

                    this.emitFn(this.type,this.newTime);
                }
            },
            // 左右移动时间段   是否增加   类型：日、周、月、年
            toggleTime(isAdd=true,type=this.type,callback){
                 if(  this.type==='日'  ){
                    if(  isAdd  )  this.newTime += 24*60*60*1000;
                    else  this.newTime -= 24*60*60*1000;
                }
                else if(  this.type==='周'  ){
                    if(  isAdd  )  this.newTime += 24*60*60*1000*7;
                    else  this.newTime -= 24*60*60*1000*7;
                }
                else if(  this.type==='月'  ){
					let oDate = new Date(this.newTime);
					let num = oDate.getMonth();
					num = isAdd ? num+1 : num-1;
					oDate.setMonth(num);
					
					this.newTime = oDate.getTime();
                }
                else if(  this.type==='年'  ){
                    let oDate = new Date(this.newTime);
                    // let oDate = time(this.newTime);
                    let num = oDate.getFullYear();
                    num = isAdd ? num+1 : num-1;
                    oDate.setFullYear(num);

                    this.newTime = oDate.getTime();
                }

                if( callback ){  callback();  }
            },

        },
        created(){
            // 初始化-------------------------------------------------------------------------------------------------------------------
            console.log(" toggleTime  created: ");
            this.emitFn(this.type,this.newTime);
            // this.test = this.$route.query.newTime;


            // app调js：接受app发送过来的数据res
            this.$bridge.registerHandler("vitaJsBridgeFromNative",  (res) => {
                console.log("app调js res: ",res);
                // alert(time(result.data.newTime).format("YYYY-MM-DD HH:mm:ss"));

                let result=JSON.parse(res);
                this.newTime = result.data.newTime;
                this.type = result.data.type;
            });
        },
        mounted(){
              console.log(" toggleTime  mounted: ");
        },
    }
</script>

<style scoped>

</style>